import { render, staticRenderFns } from "./processing-customer-multiselect-ajax.vue?vue&type=template&id=cb76b2cc&scoped=true&"
import script from "./processing-customer-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./processing-customer-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb76b2cc",
  null
  
)

export default component.exports